var browserPrefixes = ['moz', 'ms', 'o', 'webkit']; // internal flag, defaults to true

// get the correct attribute name
function getHiddenPropertyName(prefix) {
  return (prefix ? prefix + 'Hidden' : 'hidden');
}

// get the correct event name
function getVisibilityEvent(prefix) {
  return (prefix ? prefix : '') + 'visibilitychange';
}

// get current browser vendor prefix
function getBrowserPrefix() {
  for (var i = 0; i < browserPrefixes.length; i++) {
    if(getHiddenPropertyName(browserPrefixes[i]) in document) {
      // return vendor prefix
      return browserPrefixes[i];
    }
  }

  // no vendor prefix needed
  return null;
}

// bind and handle events
var browserPrefix = getBrowserPrefix(),
    hiddenPropertyName = getHiddenPropertyName(browserPrefix),
    visibilityEventName = getVisibilityEvent(browserPrefix);

function isVisible(forcedFlag) {
  if(typeof forcedFlag === "boolean") {
    if(forcedFlag) {
      return true;
    }

    return false;
  }

  if(document[hiddenPropertyName]) {
    return false;
  }

  return true;
}

const funcs = {
  addEventListener: function(callback) {
    document.addEventListener('focus', function() {
      callback(isVisible(true));
    }, false);

    document.addEventListener('blur', function() {
      callback(isVisible(false));
    }, false);

    window.addEventListener('focus', function() {
      callback(isVisible(true));
    }, false);

    window.addEventListener('blur', function() {
      callback(isVisible(false));
    }, false);

    document.addEventListener(visibilityEventName, function() {
      callback(isVisible(false));
    }, false);
  },
  removeEventListener: function(callback) {
    document.removeEventListener('focus', function() {
      callback(isVisible(true));
    });

    document.removeEventListener('blur', function() {
      callback(isVisible(false));
    });

    window.removeEventListener('focus', function() {
      callback(isVisible(true));
    });

    window.removeEventListener('blur', function() {
      callback(isVisible(false));
    });

    document.removeEventListener(visibilityEventName, function() {
      callback(isVisible(false));
    });
  }
}

export default funcs;

